module.exports = __webpack_public_path__ + "static/media/dish14.ac47647d.jpg";